export default __webpack_public_path__ + "ee445e8abb3354203b6fb85379ea3b43.pdf";